import { render } from "./BulkUsage.vue?vue&type=template&id=45790a41&scoped=true"
import script from "./BulkUsage.vue?vue&type=script&lang=js"
export * from "./BulkUsage.vue?vue&type=script&lang=js"

import "./BulkUsage.vue?vue&type=style&index=0&id=45790a41&lang=scss&scoped=true"

import exportComponent from "/Users/klaus/Projects/sfdc-happy-soup/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45790a41"]])

export default __exports__